import { NewAutoCompleteField } from "@components/form/AutocompleteField";
import { AutocompleteProps } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

export interface IOption {
    value: any;
    label: string;
    img?: string;
}

interface IRHAAutoCompleteWithZeroProps {
    name: string;
    dense?: boolean;
    label?: string;
    disabled?: boolean;
    options: IOption[];
    sx?: any;
    placeholder?: string;
}

const RHAAutoCompleteWithZero = (
    props: IRHAAutoCompleteWithZeroProps &
        Omit<
            AutocompleteProps<any, boolean, boolean, boolean, any>,
            "onChange" | "renderInput"
        >,
) => {
    const {
        name,
        options,
        dense = false,
        label,
        disabled,
        freeSolo,
        placeholder,
        ...other
    } = props;
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => {
                const { onChange, value, ref } = field;

                const handleChange = (newValue: IOption | string) => {
                    const val = typeof newValue === "string" ? newValue : newValue?.value ?? null;
                    onChange(val);
                };

                const getValue = () => {
                    if (value == null) return null;

                    if (value === 0 || value === "0") {
                        const zeroOption = options.find(option =>
                            option.value === 0 || option.value === "0"
                        );
                        return zeroOption || null;
                    }

                    const found = options.find(option => {
                        return option.value === value;
                    });

                    return found || (freeSolo ? value : null);
                };

                return (
                    <NewAutoCompleteField
                        label={label}
                        value={getValue()}
                        onChange={(event: any, newValue: IOption | string) =>
                            handleChange(newValue)
                        }
                        options={options}
                        error={error?.message}
                        disabled={disabled}
                        freeSolo={freeSolo}
                        placeholder={placeholder}
                        {...other}
                    />
                );
            }}
        />
    );
};

export default RHAAutoCompleteWithZero;